import React from 'react';
import { observer } from 'mobx-react';
import ReportsComponent from './Reports.component';
import useReports from './useReports';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';
import { toJS } from 'mobx';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { lang, telemetry, state, handlers, refs, reports } = useReports();




    return (
        <>
            <ReportsComponent
                page={state.page}
                rows={state.rows}
                columns={state.columns}
                lang={lang.lang}
                sortModel={reports.sortModel}
                limit={telemetry.limit}
                columnVisibilityModel={reports.columnVisibilityModel}
                visibilitySettingsState={state.visibilitySettingsState}
                visibilitySettingsEl={state.visibilitySettingsEl}
                visibilitySettingsRef={refs.visibilitySettingsRef}
                loading={reports.loading}
                onPageChange={handlers.handlePageChange}
                onDownloadClick={handlers.handleDownloadClick}
                onSortModelChange={handlers.handleSortModelChange}
                onUnsort={handlers.handleUnsort}
                onAscSort={handlers.handleAscSort}
                onDescSort={handlers.handleDescSort}
                onVisibilitySettingsStateChange={
                    handlers.handleVisibilitySettingsStateChange
                }
                onVisibilitySettingsStateClose={
                    handlers.handleVisibilitySettingsStateClose
                }
                onHideCol={handlers.handleHideCol}
                onToggleCol={handlers.handleToggleCol}
                onShowAllCol={handlers.handleShowAllCol}
                onHideAllCol={handlers.handleHideAllCol}
                onLimitChange={handlers.handeLimitChange}
                onClose={onClose}
            />
        </>
    );
};

const ReportsContainer = observer(Container);

export default ReportsContainer;
